import { createI18n } from 'vue-i18n'
import messages from '@/locales'

// 检测浏览器语言
const detectBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage || 'zh-CN'

  // 标准化语言代码
  const normalizeLanguageCode = (code) => {
    if (!code) return 'zh-CN'

    const parts = code.split(/[-_]/)
    if (parts.length === 1) {
      const langMap = {
        'zh': 'zh-CN',
        'en': 'en-US',
        'es': 'es-ES',
        'ja': 'ja-JP',
        'ko': 'ko-KR',
        'fr': 'fr-FR'
      }
      return langMap[parts[0].toLowerCase()] || 'zh-CN'
    }

    const lang = parts[0].toLowerCase()
    if (lang === 'zh') return 'zh-CN'
    if (lang === 'en') return 'en-US'
    if (lang === 'es') return 'es-ES'
    if (lang === 'ja') return 'ja-JP'
    if (lang === 'ko') return 'ko-KR'
    if (lang === 'fr') return 'fr-FR'

    return 'zh-CN' // 默认中文
  }

  const normalizedLang = normalizeLanguageCode(browserLang)

  // 检查是否支持该语言
  const supportedLangs = Object.keys(messages)
  return supportedLangs.includes(normalizedLang) ? normalizedLang : 'zh-CN'
}

// 获取初始语言（优先使用浏览器语言）
const initialLocale = detectBrowserLanguage()

// 创建并导出全局 i18n 实例，供非组件模块使用
const i18n = createI18n({
  locale: initialLocale,
  fallbackLocale: 'zh-CN',
  legacy: false,
  globalInjection: true,
  messages
})

export default i18n
